import { themeStore } from "@/stores/theme";
import { TextareaProps } from "@chakra-ui/react";

export const getFillTextareaProps = (): TextareaProps => {
  const { filledInputBgColor, borderRadius } = themeStore.styles;
  return {
    border: "none",
    color: "text.input",
    bg: filledInputBgColor,
    borderRadius,
    fontSize: "16px",
    _focus: {
      border: "1px solid",
      borderColor: "brand.active",
      boxShadow: "0px 0px 1px #36C19E",
    },
    _hover: {
      border: "1px solid",
      borderColor: "line.darkGray",
    },
  };
};
